<template>
  <v-ons-page class="l-home l-content">
    <div class="container">
      <v-ons-button v-for="page of pages" :key="page.label" v-if="user.project || !page.project_only"
        modifier="large" @click="push(page.component, page.label)"
      >
        <i :class="page.icon"></i>{{ $t(page.label) }}<i class="absoluteIcon" :class="page.icon"></i>
      </v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
import KeyMoments from './KeyMoments.vue';
import Documents from './Documents.vue';
import Payments from './Payments.vue';
import Shippings from './Shippings.vue';
import Keyholding from './Keyholding.vue';

export default {
  data () {
    return {
      user: loggedIn,
      pages: [
        {
          component: KeyMoments,
          label: 'Mes moments-clés',
          icon: 'far fa-calendar-alt',
          project_only: true
        },
        {
          component: Documents,
          label: 'Mes documents',
          icon: 'fas fa-folder',
          project_only: true
        },
        {
          component: Payments,
          label: 'Mes paiements',
          icon: 'fas fa-money-check-alt',
          project_only: true
        },
        {
          component: Shippings,
          label: 'Mes livraisons',
          icon: 'fas fa-truck-loading',
          project_only: true
        },
        {
          component: Keyholding,
          label: 'Conciergerie / Location',
          icon: 'fas fa-key',
          project_only: false
        },
      ]
    };
  },
  methods: {
    push(page, key) {
      this.$store.commit('navigator/push', {
        extends: page,
        data() {
          return {
            toolbarInfo: {
              backLabel: 'Home',
              title: key
            }
          }
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// Home.vue?6b958fcc